function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _readOnlyError(r) { throw new TypeError('"' + r + '" is read-only'); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _superPropGet(t, o, e, r) { var p = _get(_getPrototypeOf(1 & r ? t.prototype : t), o, e); return 2 & r && "function" == typeof p ? function (t) { return p.apply(e, t); } : p; }
function _get() { return _get = "undefined" != typeof Reflect && Reflect.get ? Reflect.get.bind() : function (e, t, r) { var p = _superPropBase(e, t); if (p) { var n = Object.getOwnPropertyDescriptor(p, t); return n.get ? n.get.call(arguments.length < 3 ? e : r) : n.value; } }, _get.apply(null, arguments); }
function _superPropBase(t, o) { for (; !{}.hasOwnProperty.call(t, o) && null !== (t = _getPrototypeOf(t));); return t; }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
import hasInterface from '../../../../hasInterface';
import Collection from '../../../../java/util/Collection';
import Coordinate from './Coordinate';
import ArrayList from '../../../../java/util/ArrayList';
var CoordinateList = /*#__PURE__*/function (_ArrayList) {
  function CoordinateList() {
    var _this;
    _classCallCheck(this, CoordinateList);
    _this = _callSuper(this, CoordinateList);
    CoordinateList.constructor_.apply(_this, arguments);
    return _this;
  }
  _inherits(CoordinateList, _ArrayList);
  return _createClass(CoordinateList, [{
    key: "getCoordinate",
    value: function getCoordinate(i) {
      return this.get(i);
    }
  }, {
    key: "addAll",
    value: function addAll() {
      if (arguments.length === 2 && typeof arguments[1] === 'boolean' && hasInterface(arguments[0], Collection)) {
        var coll = arguments[0];
        var allowRepeated = arguments[1];
        var isChanged = false;
        for (var i = coll.iterator(); i.hasNext();) {
          this.add(i.next(), allowRepeated);
          isChanged = true;
        }
        return isChanged;
      } else return _superPropGet(CoordinateList, "addAll", this, 1).apply(this, arguments);
    }
  }, {
    key: "clone",
    value: function clone() {
      var clone = _superPropGet(CoordinateList, "clone", this, 1).call(this);
      for (var i = 0; i < this.size(); i++) {
        clone.add(i, this.get(i).clone());
      }
      return clone;
    }
  }, {
    key: "toCoordinateArray",
    value: function toCoordinateArray() {
      return this.toArray(CoordinateList.coordArrayType);
    }
  }, {
    key: "add",
    value: function add() {
      if (arguments.length === 1) {
        var coord = arguments[0];
        _superPropGet(CoordinateList, "add", this, 1).call(this, coord);
      } else if (arguments.length === 2) {
        if (arguments[0] instanceof Array && typeof arguments[1] === 'boolean') {
          var _coord = arguments[0];
          var allowRepeated = arguments[1];
          this.add(_coord, allowRepeated, true);
          return true;
        } else if (arguments[0] instanceof Coordinate && typeof arguments[1] === 'boolean') {
          var _coord2 = arguments[0];
          var _allowRepeated = arguments[1];
          if (!_allowRepeated) {
            if (this.size() >= 1) {
              var last = this.get(this.size() - 1);
              if (last.equals2D(_coord2)) return null;
            }
          }
          _superPropGet(CoordinateList, "add", this, 1).call(this, _coord2);
        } else if (arguments[0] instanceof Object && typeof arguments[1] === 'boolean') {
          var obj = arguments[0];
          var _allowRepeated2 = arguments[1];
          this.add(obj, _allowRepeated2);
          return true;
        }
      } else if (arguments.length === 3) {
        if (typeof arguments[2] === 'boolean' && arguments[0] instanceof Array && typeof arguments[1] === 'boolean') {
          var _coord3 = arguments[0];
          var _allowRepeated3 = arguments[1];
          var direction = arguments[2];
          if (direction) {
            for (var i = 0; i < _coord3.length; i++) {
              this.add(_coord3[i], _allowRepeated3);
            }
          } else {
            for (var _i = _coord3.length - 1; _i >= 0; _i--) {
              this.add(_coord3[_i], _allowRepeated3);
            }
          }
          return true;
        } else if (typeof arguments[2] === 'boolean' && Number.isInteger(arguments[0]) && arguments[1] instanceof Coordinate) {
          var _i2 = arguments[0];
          var _coord4 = arguments[1];
          var _allowRepeated4 = arguments[2];
          if (!_allowRepeated4) {
            var size = this.size();
            if (size > 0) {
              if (_i2 > 0) {
                var prev = this.get(_i2 - 1);
                if (prev.equals2D(_coord4)) return null;
              }
              if (_i2 < size) {
                var next = this.get(_i2);
                if (next.equals2D(_coord4)) return null;
              }
            }
          }
          _superPropGet(CoordinateList, "add", this, 1).call(this, _i2, _coord4);
        }
      } else if (arguments.length === 4) {
        var _coord5 = arguments[0];
        var _allowRepeated5 = arguments[1];
        var start = arguments[2];
        var end = arguments[3];
        var inc = 1;
        if (start > end) inc = -1;
        for (var _i3 = start; _i3 !== end; _i3 += inc) {
          this.add(_coord5[_i3], _allowRepeated5);
        }
        return true;
      }
    }
  }, {
    key: "closeRing",
    value: function closeRing() {
      if (this.size() > 0) this.add(new Coordinate(this.get(0)), false);
    }
  }, {
    key: "getClass",
    value: function getClass() {
      return CoordinateList;
    }
  }, {
    key: "interfaces_",
    get: function get() {
      return [];
    }
  }]);
}(ArrayList);
export { CoordinateList as default };
CoordinateList.constructor_ = function () {
  if (arguments.length === 0) {} else if (arguments.length === 1) {
    var coord = arguments[0];
    this.ensureCapacity(coord.length);
    this.add(coord, true);
  } else if (arguments.length === 2) {
    var _coord6 = arguments[0];
    var allowRepeated = arguments[1];
    this.ensureCapacity(_coord6.length);
    this.add(_coord6, allowRepeated);
  }
};
CoordinateList.coordArrayType = new Array(0).fill(null);